import React from 'react'

const Replace = (props) => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill={props.color ? props.color : "#1D79FB"} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.00334 0.666748C7.47674 0.666748 8.80855 1.26273 9.77236 2.22675L11.3333 0.666748V5.33342H6.66375L8.81176 3.18675C8.0919 2.46068 7.10565 2.00084 5.99941 2.00008C4.26002 2.00176 2.78091 3.11458 2.23431 4.66675H2.22252C2.14651 4.8812 2.0883 5.10401 2.04968 5.33341H0.707798C1.03495 2.70168 3.27408 0.666748 5.99667 0.666748H6.00334Z"
    />
    <path
      d="M0.666668 6.66675V11.3334L2.22764 9.77342C3.19145 10.7374 4.52326 11.3334 5.99667 11.3334L6.00334 11.3334C8.72592 11.3334 10.965 9.29848 11.2922 6.66675H9.95032C9.9117 6.89615 9.85349 7.11896 9.77748 7.33342H9.76569C9.21911 8.88552 7.74009 9.99832 6.00079 10.0001C4.89446 9.99937 3.90814 9.53952 3.18824 8.81341L5.33625 6.66675H0.666668Z"
    />
  </svg>
)

export default Replace
